import moment from 'moment-timezone';
import { SAMPLES_TABLE_MODE } from '@/tools/exportOData/odata.constants';
import type { RangeField } from '@/core/DateTimeRange.molecule';
import type { ExportExcelPanelTimeRange } from '@/tools/exportExcel/exportExcelPanel.store';
import type { SamplesTableMode } from '@/tools/exportExcel/exportExcelPanel.types';
import type { ValueWithUnitsItem } from '@/trend/ValueWithUnits.atom';

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const YEAR_MS = 365.25 * DAY_MS;

/**
 * Generates the default grid size for a duration in milliseconds. Same as the values in
 * ExportUtilities.kt#getAutomaticResamplePeriod
 */
export function generateDefaultGridSize(durationMs: number): ValueWithUnitsItem {
  const gridLookup: Array<[number, ValueWithUnitsItem]> = [
    [15 * MINUTE_MS, { value: 1, units: 'second' }], // 0-900 rows
    [3 * HOUR_MS, { value: 15, units: 'second' }], // 60-720 rows
    [12 * HOUR_MS, { value: 30, units: 'second' }], // 360-1440 rows
    [3 * DAY_MS, { value: 1, units: 'min' }], // 720-4320 rows
    [14 * DAY_MS, { value: 5, units: 'min' }], // 864-4032 rows
    [62 * DAY_MS, { value: 30, units: 'min' }], // 672-2976 rows
    [185 * DAY_MS, { value: 1, units: 'hour' }], // 1488-4440 rows
    [5 * YEAR_MS, { value: 1, units: 'day' }], // 185-1827 rows
  ];
  const match = gridLookup.find(([key]) => durationMs <= key);
  return match?.[1] ?? { value: 7, units: 'day' }; // 260-N rows
}

export function getExportExcelPanelSamplesMode(chainView: boolean, capsuleTime: boolean): SamplesTableMode {
  if (chainView) {
    return SAMPLES_TABLE_MODE.CHAIN;
  } else if (capsuleTime) {
    return SAMPLES_TABLE_MODE.CAPSULE;
  } else {
    return SAMPLES_TABLE_MODE.CALENDAR;
  }
}

export function buildExportExcelPanelTimeRange(timeRange: ExportExcelPanelTimeRange): RangeField<moment.Moment> {
  return {
    end: moment.utc(timeRange.end),
    start: moment.utc(timeRange.start),
  };
}
